"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtRefrash = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtRefrash = function SvgBtRefrash(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.7143 6C19.3987 6 19.1428 6.25584 19.1428 6.57144V8.65885C16.2009 5.81063 11.5071 5.88663 8.65883 8.82854C7.31654 10.215 6.56771 12.0702 6.57142 14C6.57142 14.3156 6.82726 14.5714 7.14286 14.5714C7.45847 14.5714 7.71427 14.3156 7.71427 14C7.71497 10.5285 10.5297 7.71482 14.0012 7.71552C15.7643 7.71586 17.4461 8.45665 18.6366 9.75713L16.1052 10.6011C15.8054 10.7009 15.6431 11.0247 15.7429 11.3245C15.8426 11.6243 16.1665 11.7865 16.4663 11.6868L19.8949 10.544C20.1289 10.466 20.2865 10.2466 20.2857 9.99997V6.57141C20.2857 6.25584 20.0299 6 19.7143 6Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.8571 13.4282C20.5415 13.4282 20.2857 13.6841 20.2857 13.9997C20.285 17.4712 17.4703 20.2848 13.9987 20.2841C12.2357 20.2838 10.5538 19.543 9.3634 18.2425L11.8948 17.3985C12.1946 17.2988 12.3568 16.9749 12.2571 16.6751C12.1573 16.3753 11.8335 16.2131 11.5337 16.3128L8.10511 17.4557C7.87107 17.5336 7.71347 17.753 7.71424 17.9997V21.4282C7.71424 21.7438 7.97007 21.9997 8.28568 21.9997C8.60128 21.9997 8.85711 21.7438 8.85711 21.4282V19.3408C11.7991 22.189 16.4929 22.1131 19.3411 19.1711C20.6834 17.7847 21.4322 15.9294 21.4285 13.9997C21.4286 13.6841 21.1727 13.4282 20.8571 13.4282Z",
    fill: "currentColor"
  }));
};

exports.SvgBtRefrash = SvgBtRefrash;